import { useEffect, useState } from 'react';
import { isMobileDevice } from './helpers';

export const useMobileDetect = () => {
	const [deviceInfo, setDeviceInfo] = useState(isMobileDevice());

	useEffect(() => {
		const handleResize = () => {
			setDeviceInfo(isMobileDevice());
		};

		window.addEventListener('resize', handleResize);

		setDeviceInfo(isMobileDevice());

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return deviceInfo;
};

export const useScript = (url: string) => {
	useEffect(() => {
		const script = document.createElement('script');

		script.src = url;
		script.async = true;

		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, [url]);
};
